import {
  IonContent,
  IonPage,
  IonRouterLink,
  IonTitle,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
} from "@ionic/react";
import React from "react";
import { HelpoHeader } from "../components/shared/HelpoHeader";
import { magnetOutline } from "ionicons/icons";

export const NotFoundPage: React.FC = () => (
  <IonPage>
    <HelpoHeader title="Not Found" hideBackButton />
    <IonContent>
      <IonGrid>
        <IonRow>
          <IonCol class="ion-text-center">
            <IonIcon icon={magnetOutline} size="large"/>
            <IonTitle size="small">Sorry, that page doesn’t exist!</IonTitle>
            <IonRouterLink color="secondary" href="/">
              Go to Home
            </IonRouterLink>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonContent>
  </IonPage>
);
